import React from 'react';
import Register from '../Logins/Register';

const RegisterPage = () => {
    return (
        <>
          <Register /> 
        </>
    );
};

export default RegisterPage;